module.exports = __webpack_public_path__ + "img/vue.08f0c81f.png";